import { CouponMessageCard, TradeDiscountSuccessCard, TDSuccessCardType } from "@swiggy-private/cart-types";
// constants
import { TEXTS } from "@cart-ui/constants";
import { TD_COUPON_MODAL } from "@cart-ui/constants/Coupon";
import { tokens } from "@swiggy-private/dls-web-common/dist/components/tokens";

//helpers
import { isPopFlow, isToingFlow } from "@swiggy-private/checkout-core";

const UX4_ASSETS_PREFIX = "4_0_Assets/";
const CTA_COLOR = tokens.colors.green1;

export const getIconPath = (couponData: CouponMessageCard, appendUX4AssetsPrefix = true): string => {
    if (appendUX4AssetsPrefix && !isToingFlow() && !isPopFlow()) {
        return UX4_ASSETS_PREFIX + (couponData.icon ?? "");
    }
    return couponData.icon ?? "";
};

export const replaceAmountToAddAndSavings = (str: string, amountToAdd: string, savings: string) => {
    if (!str) {
        return "";
    }

    return str.replace("{{amount_to_add}}", amountToAdd).replace("{{savings}}", savings);
};

export const getTradeDiscountCouponCard = (tradeDiscountCouponInfo: TradeDiscountSuccessCard): CouponMessageCard => {
    const details = getTradeDiscountCardDetails(tradeDiscountCouponInfo);

    return {
        icon: tradeDiscountCouponInfo.logo_id,
        title: details.title,
        text: tradeDiscountCouponInfo.savings,
        description: tradeDiscountCouponInfo.subtitle,
        subtext: details.subtext,
        cta: {
            text: TEXTS.COUPON_SUCCESS_CTA_TEXT,
            color: CTA_COLOR,
        },
    };
};

export const getTradeDiscountCardDetails = (
    tradeDiscountCouponInfo: TradeDiscountSuccessCard,
): { title: string; subtext: string } => {
    switch (tradeDiscountCouponInfo.td_success_card_type) {
        case TDSuccessCardType.OFFER_CARD_TYPE_VALUE_MEALS: {
            return {
                title: TD_COUPON_MODAL.VALUE_MEALS.TITLE,
                subtext: TD_COUPON_MODAL.VALUE_MEALS.SUBTEXT,
            };
        }
        default:
            return {
                title: "",
                subtext: "",
            };
    }
};
